import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromTourDataStore from './state/tour-data-store.reducer';

/* effects */
import { TourDataStoreEffects } from './state/tour-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* TourDataStore State */
    StoreModule.forFeature(
      fromTourDataStore.featureKey,
      fromTourDataStore.reducer,
      { initialState: fromTourDataStore.initialState },
    ),
    EffectsModule.forFeature([TourDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class TourDataStoreModule {}
